import { render, staticRenderFns } from "./CampaignComponent.vue?vue&type=template&id=a445f70a&"
import script from "./CampaignComponent.vue?vue&type=script&lang=js&"
export * from "./CampaignComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports